var map = {
	"./70_days_3.jpg": 4838,
	"./cert_rus_6.jpg": 2518,
	"./general_english_2.jpeg": 5311,
	"./ielts_multilevel_1.jpeg": 7388,
	"./kids_english_9.jpg": 5338,
	"./kids_math_11.jpg": 6173,
	"./kids_russian_10.jpg": 8360,
	"./math_11.jpg": 3444,
	"./ogp-8.jpg": 1615,
	"./rus_lit_5.jpg": 2434,
	"./rus_speaking_7.jpg": 4804
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2357;